
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-card-tile--default--icon-width:100px;
  --sic-card-tile--default--content-padding:var(--spacing-06) 0 var(--spacing-3);
  --sic-card-tile--default--eyebrow-font-size:calc(
    var(--headline-eyebrow-min-font-size)
  );
  --sic-card-tile--default--eyebrow-line-height:calc(
    var(--headline-eyebrow-min-line-height)
  );
  --sic-card-tile--default--heading-font-size:var(--headline-02-font-size-mid);
  --sic-card-tile--default--heading-line-height:var(--headline-02-line-height);
  --sic-card-tile--default--text-color:var(--sic-heading-color);
  --sic-card-tile--default--text-padding-top:var(--spacing-02);
  --sic-card-tile--default--text-font-size:var(--body-01-font-size);
  --sic-card-tile--default--text-line-height:var(--body-01-line-height);
  --sic-card-tile--default--cta-margin-top:var(--spacing-06);
  --sic-card-tile--default--background-color:transparent;
  --sic-card-tile--default--border-color:transparent;
  --sic-card-tile--default--border-width:0;
  --sic-card-tile--default--border-radius:var(--border-radius-rounded-default);
}
`;